import { render } from "./PanelAdmin.vue?vue&type=template&id=4790aa66&ts=true"
import script from "./PanelAdmin.vue?vue&type=script&lang=ts"
export * from "./PanelAdmin.vue?vue&type=script&lang=ts"

import "./PanelAdmin.vue?vue&type=style&index=0&id=4790aa66&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__